import { Button } from '@dfh-corp-sites/ui'
import { cn } from '@dfh-corp-sites/ui/utils'
import { ChevronRight } from '@material-ui/icons'
import React, { FC } from 'react'

import SanityLink from '../../global/SanityLink'

export interface DataSheetLinkProps {
  className?: string
  href?: string | null | undefined
  rel?: string
  target?: string
  text: string
  id: string
  isProfessional?: boolean
}

const DataSheetLink: FC<DataSheetLinkProps> = ({
  className = '',
  href = null,
  rel = 'noopener',
  target = '_blank',
  text,
  id,
  isProfessional = false,
}) => {
  if (!href || (id === 'doc_tech_sheet' && !isProfessional)) {
    return null
  }

  return (
    <Button asChild variant="text" className={cn('text-sm xl:text-xl', className)}>
      <SanityLink
        to={href}
        rel={rel}
        target={target}
        aria-label={`Link to ${text}`}
        className="inline-flex items-center gap-1.5"
      >
        {text} <ChevronRight />
      </SanityLink>
    </Button>
  )
}

export default DataSheetLink
